const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  containerId: (lambdaParameter, value) =>
    `${lambdaParameter}.ContainerId.Equals(${value})`,
  targetContainerId: (lambdaParameter, value) =>
    `${lambdaParameter}.TargetContainerId.Equals(${value})`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
